module.exports = __webpack_public_path__ + "static/media/thumbnail.0ad48e43.jpg";